export default __webpack_public_path__ + "static/media/sun-active.87dc2b0e.svg";